export default "__VITE_ASSET__DpGFMP5___"